import { MetricBox } from 'components/UI/V3/MetricBox/MetricBox';
import { FunctionComponent } from 'react';

import { formatInt } from '../utils';
import styles from './LoyaltySummary.module.scss';

interface LoyaltySummaryProps {
    totalPointsEarned: number;
    pendingPoints: number;
    /** Dollar amount of wallet credit issued. */
    walletCreditIssued: number;
    activeCustomers: number;
    isLoading?: boolean;
}

/**
 * Summary metrics strip on the Loyalty view. Renders four program-level totals
 * using the shared V3 `MetricBox` so the visual language matches other Cuddles
 * metric strips. The row stays a single horizontal row at every viewport and
 * scrolls horizontally on narrow screens (see `.root` overflow) rather than
 * wrapping or stacking.
 */
export const LoyaltySummary: FunctionComponent<LoyaltySummaryProps> = ({
    totalPointsEarned,
    pendingPoints,
    walletCreditIssued,
    activeCustomers,
    isLoading
}) => {
    return (
        <div className={styles.root}>
            <MetricBox
                className={styles.metricBox}
                title="Total Loyalty Points Earned"
                value={formatInt(totalPointsEarned)}
                isLoading={isLoading}
            />
            <MetricBox
                className={styles.metricBox}
                title="Pending Loyalty Points"
                value={formatInt(pendingPoints)}
                isLoading={isLoading}
            />
            <MetricBox
                className={styles.metricBox}
                title="Wallet Credit Issued"
                value={formatCurrency(walletCreditIssued)}
                isLoading={isLoading}
            />
            <MetricBox
                className={styles.metricBox}
                title="Active Customers"
                value={formatInt(activeCustomers)}
                isLoading={isLoading}
            />
        </div>
    );
};

/** USD currency with two decimals, e.g. 630 -> "$630.00". */
const formatCurrency = (value: number): string =>
    Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' });

export default LoyaltySummary;
